/**
 * ModalControls Component
 *
 * Handles modal navigation and control buttons including:
 * - Close button
 * - Back arrow (to return to image from metadata)
 * - Left/Right navigation arrows
 */

import React from 'react'
import leftArrow from '../../../assets/images/lft-arrow.png'
import rightArrow from '../../../assets/images/rt-arrow.png'
import cancelBtn from '../../../assets/images/cancel.png'
import { useModalNavigation } from '../hooks/useModalNavigation'

const ModalControls = ({
  state,
  dispatch,
  onClose,
  props,
  showBackButton = true,
  showNavigationArrows = true,
  arrowsOnly = null // 'left', 'right', or null for both
}) => {
  const { handleModalArrowClick, handleModalStatusChange, handleModalClose } =
    useModalNavigation()

  const handleCloseClick = e => {
    if (onClose && typeof onClose === 'function') {
      onClose()
    } else {
      handleModalClose(props, e)
    }
  }

  const handleBackClick = () => {
    handleModalStatusChange({ state, dispatch }, 'Image')
  }

  const handleLeftArrowClick = () => {
    handleModalArrowClick(props, 'left')
  }

  const handleRightArrowClick = () => {
    handleModalArrowClick(props, 'right')
  }

  return (
    <>
      {(showBackButton || !arrowsOnly) && (
        <div className="close-modal-container">
          {showBackButton && state.modalStatus !== 'MetaData' && (
            <div
              className={`back-arrow-container ${
                state.modalStatus !== 'Image' ? 'active' : ''
              }`}
            >
              <img
                alt="Back to asset"
                src={leftArrow}
                className="back-modal-icon"
                onClick={handleBackClick}
              />
            </div>
          )}
          {!arrowsOnly && (
            <img
              src={cancelBtn}
              className="close-modal-icon"
              alt="Close modal"
              onClick={handleCloseClick}
            />
          )}
        </div>
      )}

      {/* Modal Navigation Arrows */}
      {showNavigationArrows && state.modalStatus !== 'MetaData' && (
        <>
          {(!arrowsOnly || arrowsOnly === 'left') && (
            <div className="scroll-container lf-arrow">
              <img
                src={leftArrow}
                alt="Previous"
                className="scroll-arrow"
                onClick={handleLeftArrowClick}
              />
            </div>
          )}
          {(!arrowsOnly || arrowsOnly === 'right') && (
            <div className="scroll-container rt-arrow">
              <img
                src={rightArrow}
                alt="Next"
                className="scroll-arrow"
                onClick={handleRightArrowClick}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}

export default ModalControls
